export enum ExtensionType {
    Extension = 1,
    Restoration = 2,
    TopUp = 3,
    PlanChange = 4,
    InternationalCalling = 5,
}